import FlexPane from './_flex-pane.js'
import CollapsibleMeetingPane from './_collapsible-meeting-pane.js'
import RaceCouponsSkeleton from './_race-coupons-skeleton.js'
import LoaderSuspense from './_loader-suspense.js'

export default {
  name: 'RaceCouponsView',
  values: {
    mainContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    couponContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          _mobile_padding: '0 8px',
        },
      },
    },
    collapsibleMeetingPane: {
      configSet: CollapsibleMeetingPane,
      configValues: {},
    },
    raceCouponsSkeleton: {
      configSet: RaceCouponsSkeleton,
      configValues: {},
    },
    skeletonLoader: {
      configSet: LoaderSuspense,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
